<template>
  <div class="wrapper">
    <div class="wrapper-body">
      <div class="left-panel">
        <div class="left-panel-header">
          <div class="left-panel-header-title">
            <span>EVENT SESSIONS</span>
            <b-button type="is-primary" outlined @click="addEvent()">ADD EVENT</b-button>
          </div>
          <div class="left-panel-header-option"></div>
        </div>
        <div class="left-panel-body">
          <div v-if="event_sessions && event_sessions.length > 0">
            <div class="events-session-item" v-for="(item, index) in event_sessions" :key="index"
              @click="selectEventSession(item)" :class="{
                active:
                  selected_event_session &&
                  selected_event_session.id == item.id,
              }">
              <div v-if="item.coverImage" class="events-session-item-cover-image-panel">
                <img :src="$store.state.ASSETS_BASE_URL +
                  '/assets/uploaded/' +
                  item.coverImage
                  " />
              </div>
              <div class="events-session-item-top-panel">
                <div class="events-session-item-image">
                  <img :src="$store.state.ASSETS_BASE_URL +
                    '/assets/uploaded/' +
                    item.logoImage
                    " />
                </div>
                <div class="events-session-item-title">
                  <span>{{ item.title }}</span>
                </div>
                <div class="events-session-item-option">
                  <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                    <template #trigger>
                      <b-icon icon="dots-vertical"></b-icon>
                    </template>

                    <b-dropdown-item v-clipboard:copy="getEventPublicLink(item.slug)"
                      v-clipboard:success="onCopy" v-clipboard:error="onCopyError" aria-role="listitem">Get
                      Link</b-dropdown-item>
                    <b-dropdown-item v-if="item.allowBookingForm == 1"
                      v-clipboard:copy="getBookingFormLink(item.id)"
                      v-clipboard:success="onCopyBookingLink" v-clipboard:error="onCopyError" aria-role="listitem">
                      Copy Booking Form Link</b-dropdown-item>
                    <b-dropdown-item @click="updateEventSession(item)" aria-role="listitem">
                      Update</b-dropdown-item>
                    <b-dropdown-item @click="deleteEventSession(item)" aria-role="listitem">
                      Delete</b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
              <div class="events-session-item-body-panel"></div>
              <div class="events-session-item-bottom-panel">
                <div class="events-session-item-bottom-left">
                  <div class="events-session-item-startdate">
                    <b-icon icon="calendar"></b-icon>
                    <span>Start Date:
                      {{
                        moment(item.startTime).format("MMMM Do YYYY, h:mm A")
                      }}</span>
                  </div>
                  <div class="events-session-item-enddate">
                    <b-icon icon="calendar"></b-icon>
                    <span>End Date:
                      {{
                        moment(item.endTime).format("MMMM Do YYYY, h:mm A")
                      }}</span>
                  </div>
                </div>
                <div class="events-session-item-bottom-left">
                  <b-tag v-if="item.status == 'public'" type="is-success">Public</b-tag>
                  <b-tag v-if="item.status == 'unlisted'" type="is-danger">Unlisted</b-tag>
                  <b-tag v-if="item.status == 'private'" type="is-warning">Private</b-tag>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rigth-panel active_session" v-if="selected_event_session">
        <div class="rigth-panel-header">
          <div class="rigth-panel-header-title">
            <span>{{ selected_event_session.title }}</span>
            <div class="rigth-panel-header-actions">
              <b-field v-if="switch_tab != 'overview'" class="header-search-field">
                <b-input
                  placeholder="Search..."
                  type="search"
                  icon="magnify"
                  v-model="search_query"
                  @input="onSearchTicket">
                </b-input>
              </b-field>
              <p @click="resetSession()">Close</p>
            </div>
          </div>
        </div>
        <div class="rigth-panel-body">
          <div class="rigth-panel-body-header">
            <div class="rigth-panel-body-header-left-options">
              <button :class="{ active: switch_tab == 'overview' }" @click="switchTab('overview')">OVERVIEW</button>
              <button :class="{ active: switch_tab == 'bought' }" @click="switchTab('bought')">BOUGHT TICKETS</button>
              <button :class="{ active: switch_tab == 'used' }" @click="switchTab('used')">USED TICKETS</button>
              <button v-if="selected_event_session && selected_event_session.allowBookingForm == 1"
                :class="{ active: switch_tab == 'bookings' }" @click="switchTab('bookings')">BOOKINGS</button>
            </div>
          </div>

          <div v-if="switch_tab == 'overview'" class="overview-panel">
            <div class="overview-section">
              <span class="overview-section-title">Event Details</span>
              <div class="overview-details-grid">
                <div class="overview-card">
                  <span class="overview-label">Visibility</span>
                  <div class="overview-value">
                    <b-tag v-if="selected_event_session.status == 'public'" type="is-success">Public</b-tag>
                    <b-tag v-if="selected_event_session.status == 'unlisted'" type="is-danger">Unlisted</b-tag>
                    <b-tag v-if="selected_event_session.status == 'private'" type="is-warning">Private</b-tag>
                  </div>
                </div>

                <div class="overview-card">
                  <span class="overview-label">USSD Code</span>
                  <div class="overview-copy-row">
                    <span class="overview-copy-text">{{ eventUssdCode }}</span>
                    <b-button size="is-small" type="is-primary" outlined
                      v-clipboard:copy="eventUssdCode"
                      v-clipboard:success="onCopyUssd"
                      v-clipboard:error="onCopyError">
                      Copy
                    </b-button>
                  </div>
                </div>

                <div v-if="selected_event_session.allowBookingForm == 1" class="overview-card">
                  <span class="overview-label">Booked</span>
                  <div class="overview-value">
                    <span>{{ bookingCountLabel }}</span>
                  </div>
                </div>

                <div class="overview-card overview-card-full">
                  <span class="overview-label">Public Link</span>
                  <div class="overview-copy-row">
                    <span class="overview-copy-text">{{ eventPublicLink }}</span>
                    <b-button size="is-small" type="is-primary" outlined
                      v-clipboard:copy="eventPublicLink"
                      v-clipboard:success="onCopy"
                      v-clipboard:error="onCopyError">
                      Copy
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <div class="overview-section">
              <span class="overview-section-title">QR Codes</span>
              <div class="overview-qr-grid">
                <div class="overview-card overview-qr-card">
                  <span class="overview-label">USSD QR Code</span>
                  <div class="overview-qr-container">
                    <widgetQrCodePreview :value="eventUssdTelLink" />
                  </div>
                  <b-button size="is-small" type="is-primary" outlined icon-left="download"
                    @click="downloadQrCode(eventUssdTelLink, 'ussd')">
                    Download
                  </b-button>
                </div>
                <div class="overview-card overview-qr-card">
                  <span class="overview-label">Event Link QR Code</span>
                  <div class="overview-qr-container">
                    <widgetQrCodePreview :value="eventPublicLink" />
                  </div>
                  <b-button size="is-small" type="is-primary" outlined icon-left="download"
                    @click="downloadQrCode(eventPublicLink, 'event-link')">
                    Download
                  </b-button>
                </div>
              </div>
            </div>

            <div class="overview-section">
              <div class="overview-section-header">
                <span class="overview-section-title">Ticket Inventory</span>
                <span v-if="selected_event_session.allowBookingForm == 1" class="overview-booking-count">
                  {{ booking_count }} booked<span v-if="selected_event_session.bookingLimit"> / {{ selected_event_session.bookingLimit }}</span>
                </span>
              </div>

              <div v-if="!loading_overview && ticket_inventory.length > 0" class="overview-table-wrap">
                <table class="overview-table">
                  <thead>
                    <tr>
                      <th>TICKET TYPE</th>
                      <th>PRICE</th>
                      <th class="is-numeric">SOLD</th>
                      <th class="is-numeric">REMAINING</th>
                      <th class="is-numeric">TOTAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in ticket_inventory" :key="index">
                      <td data-label="Ticket Type">
                        <span class="ticket-type-name">{{ item.name }}</span>
                        <span v-if="item.type == 'subevents'" class="ticket-type-meta">
                          {{ getSubEventLabel(item) }}
                        </span>
                      </td>
                      <td data-label="Price">
                        <span v-if="item.amount_range_enabled">
                          {{ item.currency }} {{ item.min_amount }} - {{ item.max_amount }}
                        </span>
                        <span v-else>{{ item.currency }} {{ item.amount }}</span>
                      </td>
                      <td class="is-numeric" data-label="Sold">{{ getSoldTickets(item) }}</td>
                      <td class="is-numeric" data-label="Remaining">
                        <span class="remaining-badge" :class="{ 'is-low': getRemainingTickets(item) <= 5 }">
                          {{ getRemainingTickets(item) }}
                        </span>
                      </td>
                      <td class="is-numeric" data-label="Total">{{ item.quantity }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="loading_overview" class="overview-table-wrap">
                <table class="overview-table">
                  <thead>
                    <tr>
                      <th>TICKET TYPE</th>
                      <th>PRICE</th>
                      <th class="is-numeric">SOLD</th>
                      <th class="is-numeric">REMAINING</th>
                      <th class="is-numeric">TOTAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in 5" :key="index">
                      <td><b-skeleton width="90%"></b-skeleton></td>
                      <td><b-skeleton width="90%"></b-skeleton></td>
                      <td><b-skeleton width="90%"></b-skeleton></td>
                      <td><b-skeleton width="90%"></b-skeleton></td>
                      <td><b-skeleton width="90%"></b-skeleton></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="!loading_overview && ticket_inventory.length == 0" class="overview-empty">
                <widgetNotfound title="No Ticket Types Found"
                  subtitle="Create pricing for this event to track sold and remaining tickets.">
                </widgetNotfound>
              </div>
            </div>
          </div>

          <div class="table-widget" v-if="switch_tab == 'bought' || switch_tab == 'used'">
            <div v-if="!loading_tickets_data && event_tickets.length > 0" class="table-widget">
              <table>
                <tr>
                  <th>IDENTIFY</th>
                  <th>PAID WITH</th>
                  <th>TICKET TYPE</th>
                  <th>TICKET</th>
                  <th>STATUS</th>
                  <th>DATE</th>
                  <th></th>
                </tr>
                <tr v-for="(item, index) in event_tickets" :key="index">
                  <td>
                    <b v-if="item.bill_to_first_name"> {{ item.bill_to_first_name }} {{ item.bill_to_last_name ==
                      item.bill_to_first_name ? '' : item.bill_to_last_name }}</b>
                    <b v-else-if="item.payment_type == 'MOMO'"> {{ item.bill_to_phone }}</b>
                    <b v-else> UNKNOWN</b>
                  </td>
                  <td>{{ item.payment_type }}</td>
                  <td>{{ item.seatType }}</td>
                  <td>{{ item.ticketToken }}</td>
                  <td>
                    <b-tag v-if="switch_tab == 'bought'" type="is-success">
                      {{ item.payment_type == 'FREE' ? 'ENVITATION' : 'PAID' }}
                    </b-tag>
                    <b-tag v-if="switch_tab == 'used'" type="is-success">USED</b-tag>
                  </td>
                  <td>{{ moment(item.created_at).format("MMMM Do YYYY, h:mm a") }}</td>
                  <td>
                    <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                      <template #trigger>
                        <b-icon icon="dots-vertical"></b-icon>
                      </template>
                      <b-dropdown-item v-clipboard:copy="makeEnvitation(item.ticketToken)" v-clipboard:success="onCopy"
                        v-clipboard:error="onCopyError" aria-role="listitem">
                        Copy Ticket</b-dropdown-item>
                      <b-dropdown-item @click="resendTicketSms(item, 'ticket')" aria-role="listitem">
                        Resend SMS</b-dropdown-item>
                      <b-dropdown-item @click="deleteEventTicket(item)" aria-role="listitem">
                        Delete</b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
              </table>
            </div>

            <div v-if="loading_tickets_data" class="table-widget">
              <table>
                <tr>
                  <th>Identify</th>
                  <th>Transaction ID</th>
                  <th>PAID WITH</th>
                  <th>TICKET TYPE</th>
                  <th>STATUS</th>
                  <th>DATE</th>
                </tr>
                <tr v-for="(item, index) in 15" :key="index">
                  <td><b-skeleton width="90%"></b-skeleton></td>
                  <td><b-skeleton width="90%"></b-skeleton></td>
                  <td><b-skeleton width="90%"></b-skeleton></td>
                  <td><b-skeleton width="90%"></b-skeleton></td>
                  <td><b-skeleton width="90%"></b-skeleton></td>
                  <td><b-skeleton width="90%"></b-skeleton></td>
                </tr>
              </table>
            </div>
            <div v-if="!loading_tickets_data && event_tickets.length == 0 && switch_tab != 'bookings'"
              class="table-widget">
              <widgetNotfound title="No Event Tickets Found" subtitle="There are no event ticket data to show yet.">
              </widgetNotfound>
            </div>
          </div>

          <!-- Bookings Tab Content -->
          <div v-if="switch_tab == 'bookings'" class="table-widget">
            <div v-if="!loading_tickets_data && booking_form_data.length > 0">
              <table>
                <tr>
                  <th>NAMES</th>
                  <th>PHONE</th>
                  <th>EMAIL</th>
                  <th>TICKET TOKEN</th>
                  <th>DATE</th>
                  <th></th>
                </tr>
                <tr v-for="(item, index) in booking_form_data" :key="index">
                  <td><b>{{ item.names }}</b></td>
                  <td>{{ item.phone }}</td>
                  <td>{{ item.email || 'N/A' }}</td>
                  <td>{{ item.ticketToken }}</td>
                  <td>{{ moment(item.created_at).format("MMMM Do YYYY, h:mm a") }}</td>
                  <td>
                    <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                      <template #trigger>
                        <b-icon icon="dots-vertical"></b-icon>
                      </template>
                      <b-dropdown-item v-clipboard:copy="item.ticketToken" v-clipboard:success="onCopy"
                        v-clipboard:error="onCopyError" aria-role="listitem">
                        Copy Token</b-dropdown-item>
                      <b-dropdown-item @click="resendTicketSms(item, 'booking')" aria-role="listitem">
                        Resend SMS</b-dropdown-item>
                      <b-dropdown-item @click="deleteBooking(item)" aria-role="listitem">
                        Delete</b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
              </table>
            </div>

            <div v-if="loading_tickets_data && switch_tab == 'bookings'" class="table-widget">
              <table>
                <tr>
                  <th>NAMES</th>
                  <th>PHONE</th>
                  <th>EMAIL</th>
                  <th>TICKET TOKEN</th>
                  <th>DATE</th>
                </tr>
                <tr v-for="(item, index) in 15" :key="index">
                  <td><b-skeleton width="90%"></b-skeleton></td>
                  <td><b-skeleton width="90%"></b-skeleton></td>
                  <td><b-skeleton width="90%"></b-skeleton></td>
                  <td><b-skeleton width="90%"></b-skeleton></td>
                  <td><b-skeleton width="90%"></b-skeleton></td>
                </tr>
              </table>
            </div>

            <div v-if="!loading_tickets_data && booking_form_data.length == 0 && switch_tab == 'bookings'">
              <widgetNotfound title="No Bookings Found" subtitle="There are no booking form submissions to show yet.">
              </widgetNotfound>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="rigth-panel">
        <widgetNotfound title="No Event Selected" subtitle="Select an event session to view tickets."></widgetNotfound>
      </div>
    </div>

    <!-- Add Price Modal -->
    <addEventModal v-if="show_event_modal" @close="show_event_modal = false" :value="selected_item"
      :channel="channel_details" @success="onAddEvent()">
    </addEventModal>
  </div>
</template>

<script>
import addEventModal from "./modals/add_event_modal.vue";
import { getSubEventLabel } from "@/helpers/subEvent.js";
const QRCode = require("qrcode");

export default {
  components: {
    addEventModal,
  },
  sockets: {},
  data: () => ({
    pricing_type: "events",
    switch_tab: "overview",
    loading_tickets_data: false,
    loading_overview: false,
    show_event_modal: false,
    channel_details: null,
    event_tickets: [],
    ticket_inventory: [],
    booking_form_data: [],
    booking_form_data_all: [],
    booking_count: 0,
    search_query: '',
    selected_item: null,
    event_sessions: [],
    loading_voting_session: false,
    selected_event_session: null
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getMyChannelDetails();
    vm.getAllEvents();
    vm.loadPartnerWebsiteUrl();
  },
  methods: {
    getSubEventLabel,
    loadPartnerWebsiteUrl() {
      let vm = this;
      vm.$store
        .dispatch("ADMIN_USER_GET_WEBSITE_THEME")
        .then((response) => {
          if (response.data.return && response.data.return.webSiteBaseUrl) {
            vm.$store.commit("SET_WEB_SITE_BASE_URL", response.data.return.webSiteBaseUrl);
          }
        })
        .catch(() => { });
    },
    getEventPublicLink(slug) {
      return `${this.$getPartnerSiteBaseUrl()}watch/event/${slug}`;
    },
    getBookingFormLink(eventId) {
      return `${this.$getPartnerSiteBaseUrl()}event/booking/${eventId}`;
    },
    makeEnvitation(ticketToken) {
      let vm = this;
      let ticket_qr_code = vm.$getPartnerSiteBaseUrl() + 'tk?q=' + ticketToken;
      let envitation_message = "Welcome to our event " + vm.selected_event_session.title + ".This is your ticket, You will be asked to show token or QR code from the link:\n Token:" + ticketToken + "\nLink:" + ticket_qr_code;
      return envitation_message;
    },
    onSearchTicket(query) {
      let vm = this;

      if (vm.switch_tab === 'bookings') {
        vm.filterBookings(query);
        return;
      }

      let obj = {
        eventId: vm.selected_event_session.id,
        query: query,
        type: vm.switch_tab
      }
      vm.loading_tickets_data = true;
      vm.$store
        .dispatch("EVENTS_SEARCH_TICKET", obj)
        .then(response => {
          vm.loading_tickets_data = false;
          vm.event_tickets = response.data
        })
        .catch(error => {
          vm.loading_tickets_data = false;
          console.log(error);
        })
    },
    filterBookings(query) {
      let vm = this;
      const q = (query || '').trim().toLowerCase();

      if (!q) {
        vm.booking_form_data = [...vm.booking_form_data_all];
        return;
      }

      vm.booking_form_data = vm.booking_form_data_all.filter((item) => {
        return (
          (item.names || '').toLowerCase().includes(q) ||
          (item.phone || '').toLowerCase().includes(q) ||
          (item.email || '').toLowerCase().includes(q) ||
          (item.ticketToken || '').toLowerCase().includes(q)
        );
      });
    },
    resetSession() {
      let vm = this;
      vm.selected_event_session = null;
      vm.booking_form_data = [];
      vm.booking_form_data_all = [];
      vm.booking_count = 0;
      vm.event_tickets = [];
      vm.ticket_inventory = [];
      vm.search_query = '';
      vm.switch_tab = 'overview';
    },
    getSoldTickets(item) {
      return (item.boughtTickets || 0) + (item.freeTickets || 0);
    },
    getRemainingTickets(item) {
      const sold = this.getSoldTickets(item);
      const total = item.quantity || 0;
      return Math.max(total - sold, 0);
    },
    getEventOverview() {
      let vm = this;
      if (!vm.selected_event_session) return;

      vm.loading_overview = true;

      const pricingPromise = vm.$store.dispatch("PRICING_GET_PRICING", {
        type: vm.pricing_type,
        ref_id: vm.selected_event_session.id,
      });

      const bookingPromise = vm.selected_event_session.allowBookingForm == 1
        ? vm.$store.dispatch("EVENTS_GET_BOOKING_FORM_DATA", { eventId: vm.selected_event_session.id })
        : Promise.resolve({ data: [] });

      Promise.all([pricingPromise, bookingPromise])
        .then(([pricingResponse, bookingResponse]) => {
          vm.loading_overview = false;
          vm.ticket_inventory = (pricingResponse.data.return || []).sort((a, b) =>
            a.item_index > b.item_index ? 1 : -1
          );

          if (vm.selected_event_session.allowBookingForm == 1) {
            vm.booking_form_data_all = bookingResponse.data || [];
            vm.booking_count = vm.booking_form_data_all.length;
          } else {
            vm.booking_count = 0;
          }
        })
        .catch(() => {
          vm.loading_overview = false;
          vm.ticket_inventory = [];
          vm.booking_count = 0;
        });
    },
    addEvent() {
      let vm = this;
      vm.selected_item = null
      vm.show_event_modal = true;
    },
    onAddEvent() {
      let vm = this;
      vm.show_event_modal = false;
      vm.getAllEvents();
    },
    getMyChannelDetails() {
      let vm = this;
      vm.$store
        .dispatch("CHANNEL_GET_MY_DETAILS")
        .then((response) => {
          vm.channel_details = response.data.return;
        })
        .catch(({ response }) => {
          vm.loading_channel_details = false;
        });
    },
    getAllEvents() {
      let vm = this;
      vm.$store
        .dispatch("EVENTS_GET_ALL_EVENT")
        .then(response => {
          vm.event_sessions = response.data
        })
        .catch(error => {
          console.log(error);
        })
    },
    selectEventSession(item, type = 'overview') {
      let vm = this;
      vm.selected_event_session = item;
      vm.switch_tab = type;

      if (type === 'bookings') {
        vm.getBookingFormData(item.id);
      } else if (type === 'overview') {
        vm.getEventOverview();
      } else {
        let obj = {
          eventId: item.id,
          type: type
        }

        vm.loading_tickets_data = true;
        vm.$store
          .dispatch("EVENTS_GET_EVENT_BY_TYPE", obj)
          .then(response => {
            vm.loading_tickets_data = false;
            vm.event_tickets = response.data
          })
          .catch(error => {
            vm.loading_tickets_data = false;
            console.log(error);
          })
      }
    },
    getBookingFormData(eventId) {
      let vm = this;
      vm.loading_tickets_data = true;
      vm.$store
        .dispatch("EVENTS_GET_BOOKING_FORM_DATA", { eventId: eventId })
        .then(response => {
          vm.loading_tickets_data = false;
          vm.booking_form_data_all = response.data || [];
          vm.filterBookings(vm.search_query);
        })
        .catch(error => {
          vm.loading_tickets_data = false;
          vm.booking_form_data = [];
          vm.booking_form_data_all = [];
        })
    },
    switchTab(type) {
      let vm = this;
      vm.search_query = '';
      vm.switch_tab = type;
      if (type === 'bookings') {
        vm.getBookingFormData(vm.selected_event_session.id);
      } else if (type === 'overview') {
        vm.getEventOverview();
      } else {
        vm.selectEventSession(vm.selected_event_session, type)
      }
    },
    onCopy() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Link copied to clipboard",
        type: "is-success",
      });
    },
    onCopyUssd() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "USSD code copied to clipboard",
        type: "is-success",
      });
    },
    onCopyBookingLink() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Booking form link copied to clipboard",
        type: "is-success",
      });
    },
    onCopyError() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Failed to copy",
        type: "is-danger",
      });
    },
    downloadQrCode(value, type) {
      let vm = this;
      const session = vm.selected_event_session;
      const slug = (session && session.slug) || ("event-" + (session && session.id));
      const filename = slug + "-" + type + "-qr.png";

      QRCode.toDataURL(value, function (err, url) {
        if (err) {
          vm.$buefy.toast.open({
            message: "Failed to download QR code",
            type: "is-danger",
          });
          return;
        }

        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        vm.$buefy.toast.open({
          message: "QR code downloaded",
          type: "is-success",
        });
      });
    },
    updateEventSession(item) {
      let vm = this;
      vm.selected_item = item;
      vm.show_event_modal = true
    },
    deleteEventTicket(item) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Delete Ticket",
        message: `Are you sure you want to delete ticket <b>${item.ticketToken}</b>? This will also remove its related transaction record. This action cannot be undone.`,
        confirmText: "Delete Ticket",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          vm.$store
            .dispatch("EVENTS_DELETE_EVENT_TICKET", { id: item.id })
            .then((response) => {
              vm.$notify({
                group: "status",
                type: "success",
                title: "Success",
                text: response.data.message || "Ticket deleted successfully",
              });
              vm.refreshCurrentTab();
            })
            .catch(() => {
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: "Something went wrong, Contact your administrator",
              });
            });
        },
      });
    },
    resendTicketSms(item, type) {
      let vm = this;
      const phone = type === "booking" ? item.phone : (item.ticket_delivery_phone || item.bill_to_phone);
      const label = type === "booking" ? item.names : (item.ticketToken || "this ticket");

      vm.$buefy.dialog.confirm({
        title: "Resend SMS",
        message: phone
          ? `Resend ticket SMS to <b>${phone}</b> for <b>${label}</b>?`
          : `Resend ticket SMS for <b>${label}</b>? The system will use the phone number on record.`,
        confirmText: "Resend SMS",
        type: "is-info",
        hasIcon: true,
        onConfirm: () => {
          vm.$store
            .dispatch("EVENTS_RESEND_TICKET_SMS", { id: item.id, type })
            .then((response) => {
              vm.$notify({
                group: "status",
                type: "success",
                title: "Success",
                text: response.data.message || "SMS sent successfully",
              });
            })
            .catch((error) => {
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: (error.response && error.response.data && error.response.data.message) || "Failed to resend SMS",
              });
            });
        },
      });
    },
    deleteBooking(item) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Delete Booking",
        message: `Are you sure you want to delete the booking for <b>${item.names}</b>? This will also remove the related ticket and transaction records. This action cannot be undone.`,
        confirmText: "Delete Booking",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          vm.$store
            .dispatch("EVENTS_DELETE_BOOKING", { id: item.id })
            .then((response) => {
              vm.$notify({
                group: "status",
                type: "success",
                title: "Success",
                text: response.data.message || "Booking deleted successfully",
              });
              vm.getBookingFormData(vm.selected_event_session.id);
              vm.getEventOverview();
            })
            .catch(() => {
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: "Something went wrong, Contact your administrator",
              });
            });
        },
      });
    },
    refreshCurrentTab() {
      let vm = this;
      if (vm.switch_tab === 'bookings') {
        vm.getBookingFormData(vm.selected_event_session.id);
        return;
      }

      if (vm.switch_tab === 'overview') {
        vm.getEventOverview();
        return;
      }

      if (vm.search_query) {
        vm.onSearchTicket(vm.search_query);
      } else {
        vm.selectEventSession(vm.selected_event_session, vm.switch_tab);
      }
      vm.getEventOverview();
    },
    deleteEventSession(item) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Deleting Voting Session",
        message:
          "Are you sure you want to <b>delete</b> this event? This action cannot be undone.",
        confirmText: "Delete Event",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          console.log({ id: item.id })
          vm.$store
            .dispatch("EVENTS_DELETE_EVENT", {
              id: item.id,
            })
            .then((response) => {
              vm.selected_event_session = null;
              vm.getAllEvents();

              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
            })
            .catch(({ response }) => {
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: "Something went wrong, Contact your administrator",
              });
            });
        }
      })
    },
  },
  computed: {
    eventUssdCode() {
      if (!this.selected_event_session) return '';
      if (this.selected_event_session.customUssd) {
        return this.selected_event_session.customUssd;
      }
      return `*550*2*2*${this.selected_event_session.id}#`;
    },
    eventUssdTelLink() {
      return `tel:${this.eventUssdCode}`;
    },
    eventPublicLink() {
      if (!this.selected_event_session) return '';
      return this.getEventPublicLink(this.selected_event_session.slug);
    },
    bookingCountLabel() {
      const count = this.booking_count || 0;
      const limit = this.selected_event_session && this.selected_event_session.bookingLimit;
      if (limit) {
        return `${count} / ${limit}`;
      }
      return String(count);
    },
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: 100%;
    display: grid;
    justify-content: center;
    align-items: center;
    grid-template-columns: 35% 65%;

    @media (max-width: 860px) {
      grid-template-columns: 40% 60%;
    }

    @media (max-width: 638px) {
      grid-template-columns: 100%;
    }

    .left-panel {
      height: 100%;
      // width: 400px;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      .left-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 10px;
        border-bottom: 1px solid #ddd;
        background: #fff;

        .left-panel-header-title {
          font-size: 14px;
          font-weight: 600;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .left-panel-header-option {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .h-spacer {
            margin-right: 10px;
          }
        }
      }

      .left-panel-body {
        overflow-y: auto;
        height: calc(100% - 60px);
        display: flex;
        flex-direction: column;

        .events-session-item {
          width: 100%;
          display: flex;
          flex-direction: column;
          border-bottom: 1px solid #ddd;
          cursor: pointer;
          background: transparent;
          transition: .5s;

          &:hover {
            // background: #fff;
            background: #dbdbdb;
          }

          &.active {
            background: #dbdbdb;
          }

          .events-session-item-cover-image-panel {
            height: 100px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              height: 100%;
              width: 100%;
              object-fit: cover;
            }
          }

          .events-session-item-top-panel {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;

            .events-session-item-image {
              width: 50px;
              height: 50px;
              border-radius: 50%;
              overflow: hidden;

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }
            }

            .events-session-item-title {
              font-size: 14px;
              font-weight: 600;
              color: #333;
              width: calc(100% - 60px);
              padding: 0px 10px;
            }

            .events-session-item-option {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 10px;
            }
          }

          .events-session-item-body-panel {
            padding: 0px 10px;
          }

          .events-session-item-bottom-panel {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;

            .events-session-item-bottom-left {
              display: flex;
              flex-direction: column;

              .events-session-item-startdate,
              .events-session-item-enddate {
                font-size: 12px;
                color: #333;
                margin-bottom: 5px;
                display: flex;
                align-items: center;
              }
            }

            .events-session-item-bottom-right {
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }

    .left-panel,
    .rigth-panel {
      min-width: 0;
    }

    .rigth-panel {
      // width: calc(100% - 400px);
      height: 100%;
      background: #fff;
      border-left: 1px solid #ddd;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      @media (max-width: 638px) {
        position: absolute;
        background: white;
        z-index: 10;
        top: 0px;
        right: -800px;
        width: 85%;
        box-shadow: -10px 10px 10px rgba(0, 0, 0, 0.089);
        transition: .5s;
      }

      &.active_session {
        @media (max-width: 638px) {
          right: 0;
        }
      }

      .rigth-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 10px;
        border-bottom: 1px solid #ddd;

        .rigth-panel-header-title {
          // width: calc(100% - 200px);
          text-decoration: none;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          position: sticky;
          top: 0;
          background: white;
          width: 100%;

          span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex: 1;
            min-width: 0;
          }

          .rigth-panel-header-actions {
            display: flex;
            align-items: center;
            gap: 10px;
            flex-shrink: 0;
          }

          .header-search-field {
            margin-bottom: 0;
            min-width: 220px;

            @media (max-width: 860px) {
              min-width: 160px;
            }
          }

          p {
            display: none;
            margin-left: 0;
            color: red;
            font-weight: 700;
            cursor: pointer;
            white-space: nowrap;

            @media (max-width: 638px) {
              display: flex;
            }
          }
        }
      }

      .rigth-panel-body {
        display: flex;
        flex-direction: column;
        height: calc(100% - 60px);
        min-width: 0;
        max-width: 100%;

        .overview-panel {
          flex: 1;
          min-height: 0;
          min-width: 0;
          width: 100%;
          max-width: 100%;
          overflow-y: auto;
          overflow-x: hidden;
          padding: 20px 24px;
          background: #f5f6f8;
          display: flex;
          flex-direction: column;
          gap: 20px;

          @media (max-width: 640px) {
            padding: 16px;
          }
        }

        .overview-section {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .overview-section-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          flex-wrap: wrap;
        }

        .overview-booking-count {
          font-size: 13px;
          font-weight: 600;
          color: var(--wecodefy-secondary-color, #9fc953);
        }

        .overview-section-title {
          display: block;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.04em;
          color: #666;
          text-transform: uppercase;
        }

        .overview-details-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 16px;

          @media (max-width: 768px) {
            grid-template-columns: 1fr;
          }
        }

        .overview-card {
          background: #fff;
          border: 1px solid #e8e8e8;
          border-radius: 8px;
          padding: 16px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          min-height: 88px;
          justify-content: center;
        }

        .overview-card-full {
          grid-column: 1 / -1;
        }

        .overview-label {
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.04em;
          color: #888;
          text-transform: uppercase;
        }

        .overview-value {
          display: flex;
          align-items: center;
          min-height: 32px;
        }

        .overview-copy-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          min-height: 32px;
        }

        .overview-copy-text {
          flex: 1;
          min-width: 0;
          font-size: 14px;
          font-weight: 600;
          color: #333;
          word-break: break-all;
          line-height: 1.4;
        }

        .overview-qr-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 16px;

          @media (max-width: 768px) {
            grid-template-columns: 1fr;
          }
        }

        .overview-qr-card {
          align-items: center;
          text-align: center;
          padding-bottom: 20px;
          gap: 12px;
        }

        .overview-qr-container {
          width: 148px;
          height: 148px;
          background: #fff;
          border: 1px solid #ececec;
          border-radius: 8px;
          padding: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .overview-table-wrap {
          background: #fff;
          border: 1px solid #e8e8e8;
          border-radius: 8px;
          overflow-x: auto;
          overflow-y: hidden;
          max-width: 100%;
          -webkit-overflow-scrolling: touch;
        }

        .overview-table {
          width: 100%;
          min-width: 520px;
          border-collapse: collapse;

          thead {
            background: #fafafa;
            border-bottom: 1px solid #ececec;
          }

          th,
          td {
            padding: 14px 16px;
            font-size: 13px;
            vertical-align: middle;
            border-bottom: 1px solid #f0f0f0;
          }

          th {
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.04em;
            color: #666;
            text-transform: uppercase;
            text-align: left;
            white-space: nowrap;
          }

          tbody tr:last-child td {
            border-bottom: none;
          }

          tbody tr:hover {
            background: #fcfcfc;
          }

          .is-numeric {
            text-align: right;
            white-space: nowrap;
          }

          .ticket-type-name {
            display: block;
            font-weight: 600;
            color: #333;
          }

          .ticket-type-meta {
            display: block;
            margin-top: 4px;
            font-size: 12px;
            color: #888;
          }

          .remaining-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 32px;
            padding: 4px 10px;
            border-radius: 999px;
            background: #eef5e0;
            color: #5a7a1f;
            font-weight: 700;

            &.is-low {
              background: #fff3e0;
              color: #b35a00;
            }
          }

          @media (max-width: 640px) {
            min-width: 0;

            thead {
              display: none;
            }

            tbody tr {
              display: block;
              padding: 12px 16px;
              border-bottom: 1px solid #f0f0f0;

              &:last-child {
                border-bottom: none;
              }
            }

            tbody td {
              display: flex;
              align-items: center;
              justify-content: space-between;
              gap: 12px;
              padding: 8px 0;
              border-bottom: none;
              text-align: right;

              &::before {
                content: attr(data-label);
                font-size: 11px;
                font-weight: 700;
                letter-spacing: 0.04em;
                color: #888;
                text-transform: uppercase;
                text-align: left;
                flex-shrink: 0;
              }

              &.is-numeric {
                white-space: normal;
              }
            }

            .ticket-type-name,
            .ticket-type-meta {
              text-align: right;
            }
          }
        }

        .overview-empty {
          background: #fff;
          border: 1px solid #e8e8e8;
          border-radius: 8px;
          overflow: hidden;
        }

        .rigth-panel-body-header {
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #ececec;
          height: 60px;
          flex-shrink: 0;
          overflow-y: auto;

          .rigth-panel-body-header-left-options {
            display: flex;
            align-items: center;

            button {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%;
              padding: 0px 50px;
              border: none;
              border-bottom: 3px solid transparent;
              background: transparent;
              transition: .5s;
              white-space: nowrap;

              &:hover {
                border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
              }

              &.active {
                border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
                color: var(--wecodefy-secondary-color, #9fc953);
              }
            }
          }

          .rigth-panel-body-header-right-options {
            display: flex;
            align-items: center;
            padding-right: 10px;
          }
        }

        .table-widget {
          flex: 1;
          min-height: 0;
          overflow-y: auto;

          table {
            width: 100%;

            tr {
              th {
                white-space: nowrap;
              }

              td {
                white-space: nowrap;

                .tag-lists {
                  display: flex;
                  width: fit-content;
                  flex-shrink: 0;
                  min-width: 170px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
